import UnitDetailsPage from './UnitDetailsPage';

export default UnitDetailsPage;
